// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"957a5095","173":"bbfac832","224":"0e43ba3e","807":"e7562934","950":"ea5f0974"}[chunkId] + ".chunk.js";
};